export default {
    addEmail: {
        button: 'Add',
        description:
            'A Verification Email will be sent automatically when you add a new email. ',
        helper: 'e.g. name@example.com',
        label: 'Add Email Address',
        title: 'Add a new email',
    },
    emailAddresses: {
        delete: 'Delete',
        description:
            'Your primary address is for user notifications or password reset requests. Any of the following email addresses can be set as a Notification Address below.',
        email: 'Email',
        newDescription:
            'The "Primary" address can be used for login and is where user notifications and password reset requests are sent.',
        primary: 'Primary',
        sendConfirmationLink: 'Send Verification Email',
        setAsPrimary: 'Set as primary',
        status: 'Status',
        title: 'Email Addresses',
        unverified: 'Unverified',
        verified: 'Verified',
    },
    formTitle: 'Email Settings',
    modal: {
        description:
            'Are you sure you want to delete this email address {{email}}?',
        title: 'Delete Email Address',
    },
    notificationAddresses: {
        company: 'Company',
        description:
            "Company accounts-related activity notifications are sent to the email address you have set here. You can select from the email addresses you have added above.  If you want to change the kinds of notifications you're receiving, please go to <0>Notification Preferences.</0>",
        email: 'Email',
        save: 'Save',
        saveSuccess: 'The email address was updated successfully.',
        title: 'Addresses for Account-related Notifications',
    },
    title: 'Email Settings - Makeleaps',
};
